import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { filter, startWith, takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/core/app.state';
import { NavigationService } from 'src/app/shared/router.service';
import { initNavbarParams } from 'src/app/shared/utils/helpers';

export type OrganizeTab = 'brands' | 'categories' | 'tags';

@Component({
  selector: 'app-organize',
  templateUrl: './organize.component.html',
  styleUrls: ['./organize.component.scss'],
})
export class OrganizeComponent implements OnInit, OnDestroy {

  activeTab: OrganizeTab = 'brands';

  private destroy$ = new Subject<void>();

  constructor(
    private navigationService: NavigationService,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      startWith(null),
      takeUntil(this.destroy$),
    ).subscribe(() => {
      this.activeTab = this.resolveActiveTab(this.router.url);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onTabChange(tab: OrganizeTab): void {
    if (tab === this.activeTab) return;
    this.router.navigate(['/organize', tab]);
  }

  onActivate(_e: any): void {
    const currentActivatedRoute = this.getCurrentActivatedRoute();
    this.navigationService.setCurrentRoute(currentActivatedRoute);
    initNavbarParams(this.store, currentActivatedRoute);
  }

  onDeactivate(_e: any): void {
    initNavbarParams(this.store, null, true);
  }

  private getCurrentActivatedRoute(): ActivatedRoute | null {
    let route = this.activatedRoute.firstChild;
    while (route?.firstChild) {
      route = route?.firstChild;
    }
    return route;
  }

  private resolveActiveTab(url: string): OrganizeTab {
    const path = url.split('?')[0];
    if (path.includes('/organize/categories')) return 'categories';
    if (path.includes('/organize/tags')) return 'tags';
    return 'brands';
  }
}
